import React from "react"
import axios from "axios"
import './create-feedback-link-modal.css'
import { baseUrl } from "../../assets/Animations"
import { getRequestHeaders } from "../../api"
import DropdownFilter from "../../DanitComponents/Dropdown/DropdownFilter"
import SearchInput from "../../DanitComponents/Inputs/SearchInput"
import { convertSchoolAbbreviationsToNames } from "../../utilityFunctions"

const CreateFeedbackLinkModal = ({setCreateFeedbackLinkModal, teacher}) => {
    const [families, setFamilies] = React.useState([])
    const [filterOptions, setFilterOptions] = React.useState([])
    const [selectedFamily, setSelectedFamily] = React.useState('')
    const [selectFamilyName, setSelectFamilyName] = React.useState('')

    React.useEffect(() => {
        axios.get(`${baseUrl}/schoolsfamilies/${teacher.School.toUpperCase()}`, getRequestHeaders())
        .then(res => {
            //alphabetize the families
            res.data.sort((a, b) => {
                if(a.familyName < b.familyName) { return -1; }
                if(a.familyName > b.familyName) { return 1; }
                return 0;
            })
            setFamilies(res.data)
        })
        .catch(err => {
            console.log(err)
        })
    },[])

    React.useEffect(() => {
        if(families.length > 0) {
            let options = []
            families.forEach(family => {
                options.push({id: family.familyId, label: `${family.primaryParentName} ${family.familyName}`})
            })
            setFilterOptions(options)
        }
    }, [families])

    React.useEffect(() => {
        if(selectedFamily) {
            let selectedFamilyName = families.find(family => family.familyId === selectedFamily[0])
            setSelectFamilyName(selectedFamilyName.primaryParentName + ' ' + selectedFamilyName.familyName)
        }
    
    }, [selectedFamily])

    const chooseFamily = (familyId) => {

    }

    return (
        <div className="create-feedback-link-modal__wrapper" id="create-feedback-link-modal__wrapper" onClick={(e) => e.target.id === 'create-feedback-link-modal__wrapper' ? setCreateFeedbackLinkModal(false) : null}>
            <div className="create-feedback-link-modal">
                <div>Select ONE family to create link</div>
                <div>
                    <DropdownFilter label={'Find Family'} options={filterOptions} value={selectedFamily} onChange={value => setSelectedFamily(value)}/>
                </div>
                {selectedFamily.length === 1 && <a target="_blank" rel="noreferrer" href={`https://${convertSchoolAbbreviationsToNames(teacher.School).split(' ')[0].toLowerCase()}.atharo.app/teacher-assessment/${selectedFamily[0]}/${teacher.TeacherID}`}>Click to Submit {teacher.Name} Feedback from {selectFamilyName}</a>}
                {selectedFamily.length > 1 && <div>Too many families selected. Please only choose 1 family</div>}
            </div>
        </div>
    )
}
export default CreateFeedbackLinkModal